import { MatchingProperty } from './../models/matching-property';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { Headers, RequestOptions } from '@angular/http';
import { MatchingPropertyAssign } from '../models/matching-property-assign';
import { PropertyMatch } from '../models/property-match';

@Injectable()
export class MatchingPropertyHttpService {
  private aggregateBaseURL =  '/api/matching';
  private propertyMatchesCountURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/count';
  private propertyMatchesSearchURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/search';
  private propertyMatchesAssignURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/assign/candidate';
  private propertyMatchesAddURL: string = this.environment.baseUrl + this.aggregateBaseURL + '/assign/new';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  getPropertyMatchesCount(): Observable<number> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.get(`${this.propertyMatchesCountURL}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getPropertyMatches(page: number, size: number, sort: string): Observable<MatchingProperty> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers }); // Create a request option

    return this.http.get(`${this.propertyMatchesSearchURL}?page=${page}&size=${size}&${sort}`, options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  assign(property: MatchingPropertyAssign): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.propertyMatchesAssignURL, JSON.stringify(property.toJS()), options)
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  add(newRec: PropertyMatch): Observable<MatchingProperty> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.propertyMatchesAddURL, JSON.stringify(newRec.toJS()), options)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/matching-property.http.service.ts